// extracted by mini-css-extract-plugin
export default {"verticalWrapper":"Verticals_verticalWrapper__M4JWv","contentContainer":"Verticals_contentContainer__kEO6Y"};